module.exports = __webpack_public_path__ + "img/672.691db22b.jpg";